import React from "react";
import HeaderNav from "./HeaderNav";
import Sitelogo from "./Logo";
import UserProfile from "./UserProfile";

const Header = () => {
  return (
    <div className="header-blocks">
      <header>
        <Sitelogo />
        <HeaderNav />
        <UserProfile />
      </header>
      <div className="header-bottom-block">
        {/* <SearchBar
          setIsVisible={setIsVisible}
          setSelectedCustomer={setSelectedCustomer}
        /> */}
      </div>
    </div>
  );
};

export default Header;
